const constants = {
  googleLoginCallbackRoute: '/google-login-landing',
};

export default constants;
